"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dealerDetailsHours = _interopRequireDefault(require("../../styles/dealer-details-hours.css"));
var _dealerDetailsSecondaryHeading = _interopRequireDefault(require("./dealer-details-secondary-heading"));
var _dealerHoursListItem = _interopRequireDefault(require("./dealer-hours-list-item"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var DepartmentHoursList = function DepartmentHoursList(_ref) {
  var department = _ref.department,
    saleOpeningHoursLabel = _ref.saleOpeningHoursLabel,
    serviceOpeningHoursLabel = _ref.serviceOpeningHoursLabel,
    theme = _ref.theme;
  if (!(0, _checkProps["default"])(department) || !(0, _checkProps["default"])(saleOpeningHoursLabel) || !(0, _checkProps["default"])(serviceOpeningHoursLabel)) {
    return /*#__PURE__*/_react["default"].createElement("table", {
      className: _dealerDetailsHours["default"].hoursList
    }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
      colSpan: "2",
      className: _dealerDetailsHours["default"].tableHeader
    }, /*#__PURE__*/_react["default"].createElement(_dealerDetailsSecondaryHeading["default"], {
      theme: theme,
      headingText: department.code === 'sales' ? saleOpeningHoursLabel : department.code === 'services' ? serviceOpeningHoursLabel : ''
    })))), /*#__PURE__*/_react["default"].createElement("tbody", null, department.workingHours.map(function (hoursItem, i) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line
        _react["default"].createElement(_dealerHoursListItem["default"], {
          theme: theme,
          hoursInfo: hoursItem,
          key: i
        })
      );
    })));
  }
  return null;
};
var _default = DepartmentHoursList;
exports["default"] = _default;